import Vuex from 'vuex';
import Vue from 'vue';
import model from '~/frontend/store/modules/model';
import type from '~/frontend/store/modules/type';
import configurator from '~/frontend/store/modules/configurator';
import settings from '~/frontend/store/modules/settings';
import search from '~/frontend/store/modules/search';
import price_search from '~/frontend/store/modules/price_search';
import list from '~/admin/store/modules/list';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    model,
    type,
    configurator,
    settings,
    price_search,
    savedLeads: list,
    leads: list,
    search: search,
    blog:list
  }
});
